module.exports = __webpack_public_path__ + "img/image4.b030a47e.jpg";